import {SetStateAction, createContext, useState, useMemo} from "react";
import ListDataTable from "./components/ListDataTable";
import {Formik} from "formik";
import * as Yup from "yup";
import {FORM_TYPE} from "./constants/reportAssignment";
import {TypeFormItem} from "./models/reportAssignment";

export interface ReportAssignmentContextProps {
  listTableData: any;
  setListTableData: SetStateAction<any>;
  detailItem: any;
  setDetailItem: SetStateAction<any>;
  typeForm: TypeFormItem;
  setTypeForm: SetStateAction<any>;

}

const initialContext = {
  listTableData: [],
  setListTableData: () => {},
  detailItem: [],
  setDetailItem: () => {},
  typeForm: FORM_TYPE.ReportAssignment,
  setTypeForm: () => {},
}

export const ReportAssignmentContext = createContext<ReportAssignmentContextProps>(initialContext)

interface Props {
}

export const ReportAssignment = (props: Props) => {
  const [detailItem, setDetailItem] = useState({});
  const [listTableData, setListTableData] = useState([]);
  const [typeForm, setTypeForm] = useState(FORM_TYPE.ReportAssignment);

  let validationSchema = Yup.object({});

  const contextValue = useMemo(() => ({
    listTableData,
    setListTableData,
    detailItem,
    setDetailItem,
    typeForm,
    setTypeForm,
  }), [detailItem, listTableData, typeForm])

  return (
    <Formik<any>
      initialValues={{}}
      validationSchema={validationSchema}
      onSubmit={(values: any) => {}}
    >
      <ReportAssignmentContext.Provider value={contextValue}>
        <div className="bg-white">
          <div className="flex-1 flex flex-column">
            <div className="py-1">
              <ListDataTable className={""}/>
            </div>
          </div>
        </div>
      </ReportAssignmentContext.Provider>
    </Formik>
  )
}

export default ReportAssignment;
